import { createContext } from "react";
import * as Realm from "./Realm";
import { UserCustomData } from "./Realm.interfaces";

type RealmContext = {
  app: Realm.App;
  realmUser: Realm.User | undefined;
  realmUserData: UserCustomData;
  isLoggedIn: boolean;
  db: globalThis.Realm.Services.MongoDBDatabase;
  dbClientData: globalThis.Realm.Services.MongoDBDatabase;
  mongo: globalThis.Realm.Services.MongoDB;
  login: (provider: string, creds?: Realm.Credentials, onLogin?: Function) => Promise<Realm.User>;
  logout: () => Promise<void>;
  refreshUser: (update?: globalThis.Realm.Services.MongoDB.Filter) => Promise<any>;
  loading: boolean;
  callFunction: <T = any>(name: string, ...args: any[]) => Promise<T>;
  callFunctionRaw: <T = any>(name: string, ...args: any[]) => Promise<T>;
  apiToken: string;
};

export const RealmContext = createContext({} as RealmContext);
